import { Button, Icon, IconButton, Stack, Typography } from '@mui/material';
import {
  EditIcon,
  ListRow,
  MedicalIcon,
  PlusIcon,
  TypographyWithOverflowHint,
} from '@schooly/style';
import React from 'react';
import { useIntl } from 'react-intl';

import { useProfile } from '../../../context/profile/useProfile';
import useFlag from '../../../hooks/useFlag';
import MedicalModal from './MedicalModal';

const MedicalProperty = () => {
  const { formatMessage } = useIntl();
  const [isDialogOpen, showDialog, hideDialog] = useFlag();

  const { user, hasEditingPermission, schoolMembership } = useProfile();

  const { details = {} } = schoolMembership ?? {};

  if (!user) {
    return null;
  }

  if (!details?.allergy && hasEditingPermission) {
    return (
      <>
        <Button
          variant="text"
          startIcon={<PlusIcon />}
          onClick={showDialog}
          fullWidth
          sx={{ justifyContent: 'flex-start', textAlign: 'left', p: '10px 8px' }}
        >
          {formatMessage({ id: 'peopleDetail-AddMedicalNeeds' })}
        </Button>
        <MedicalModal
          user={user}
          studentMembership={schoolMembership}
          isOpen={isDialogOpen}
          onClose={hideDialog}
          canEdit={true}
        />
      </>
    );
  }

  return (
    <>
      {details?.allergy ? (
        <ListRow
          variant="compact"
          title={
            <Stack
              className="list-row-title"
              direction="row"
              alignItems="center"
              gap={1.25}
              minWidth={0}
              color="common.grey"
            >
              <Icon fontSize="small" sx={{ flexShrink: 0 }}>
                <MedicalIcon />
              </Icon>

              <TypographyWithOverflowHint
                variant="h3"
                color={details?.severe ? 'error.main' : 'common.grey2'}
              >
                {details.allergy}
              </TypographyWithOverflowHint>
            </Stack>
          }
          onClick={hasEditingPermission ? showDialog : undefined}
          rightContent={
            <Typography variant="h3" color="common.grey" sx={{ minWidth: 125 }}>
              {formatMessage({
                id: details?.reviewed_by_nurse
                  ? 'peopleDetail-ReviewedByNurse'
                  : 'peopleDetail-NotReviewedByNurse',
              })}
            </Typography>
          }
          actions={
            hasEditingPermission && (
              <IconButton
                className="actionIcon"
                size="small"
                sx={{ visibility: 'hidden', position: 'absolute', right: 12 }}
              >
                <EditIcon />
              </IconButton>
            )
          }
          sx={{
            borderRadius: '8px',
            borderBottom: 'none',
            '&:hover .actionIcon': { visibility: 'visible' },
          }}
        />
      ) : null}
      <MedicalModal
        user={user}
        studentMembership={schoolMembership}
        isOpen={isDialogOpen}
        onClose={hideDialog}
        canEdit={true}
      />
    </>
  );
};

export default MedicalProperty;
